module.exports = __webpack_public_path__ + "static/moving-star-75b8e24c1551c5addfa6e1e66b84f2be.png";